<div class="quick-menu-item" [ngClass]="{ active }">
  <div class="icon-container">
    <mat-icon class="icon">{{ icon }}</mat-icon>
  </div>
  <span class="text">
    <ng-content></ng-content>
  </span>
</div>
